import * as types from 'modules/screensaver/actionTypes';

/**
 * @param {Object} [meta={}]
 * @returns {import("../types/actions").ScreensaverDetailsIsReadyAction}
 */
export const screensaverDetailsIsReady = (meta = {}) => ({
  type: types.SCREENSAVER_READY,
  meta,
});
